import { LayerModel } from '../model/ui/layer.ui.model';

export class LayerConverter {
  static toDbo(source: LayerModel): any {
    return {
      project_id: source.project_id,
      name: source.name,
      default_geom_type: source.default_geom_type,
      default_entity_type: source.default_entity_type,
      public_layer: source.public_layer,
      visible_in_sub_projects: source.visible_in_sub_projects,
      default_visible: source.default_visible,
      style_points: {
        icon: source.style_descriptor.style_point.icon,
        size: source.style_descriptor.style_point.size,
        anchor: {
          t1: source.style_descriptor.style_point.anchor.t1,
          t2: source.style_descriptor.style_point.anchor.t2
        }
      },
      style_lines: {
        color: source.style_descriptor.style_line.color,
        opacity: source.style_descriptor.style_line.opacity,
        size: source.style_descriptor.style_line.size
      },
      style_polygons: {
        color: source.style_descriptor.style_polygon.color,
        fillColor: source.style_descriptor.style_polygon.fillColor,
        opacity: source.style_descriptor.style_polygon.opacity,
        fillOpacity: source.style_descriptor.style_polygon.fillOpacity,
        size: source.style_descriptor.style_polygon.size
      }
    }
  }

  static toDboForUpdate(source: LayerModel): any {
    return {
      project_id_or_scheme_name: source.project_id.toString() || '',
      layer_id: source.layer_id,
      name: source.name,
      public_layer: source.public_layer,
      visible_in_sub_projects: source.visible_in_sub_projects,
      default_visible: source.default_visible,
      style_descriptor: {
        type: "dynamic",
        style_point: {
          icon: source.style_descriptor.style_point.icon,
          size: source.style_descriptor.style_point.size,
          anchor: {
            t1: source.style_descriptor.style_point.anchor.t1,
            t2: source.style_descriptor.style_point.anchor.t2
          }
        },
        style_line: {
          color: source.style_descriptor.style_line.color,
          opacity: source.style_descriptor.style_line.opacity,
          size: source.style_descriptor.style_line.size
        },
        style_polygon: {
          color: source.style_descriptor.style_polygon.color,
          fillColor: source.style_descriptor.style_polygon.fillColor,
          opacity: source.style_descriptor.style_polygon.opacity,
          fillOpacity: source.style_descriptor.style_polygon.fillOpacity,
          size: source.style_descriptor.style_polygon.size
        }
      },
      type: "LayerEntities"
    };

  }


  static toUiMReport(source: any): any {
    return {
    }
  }
}
